import React from 'react'
import cn from 'classnames'

import 'components/graph/controls/contextualMenu.less'

type ContextualMenuToggleProps = {
  open: boolean
  onClick: () => void
  icon: React.ReactNode
  label: string
}

// A single menu-opening button, meant to be rendered as a flex item alongside its siblings
// (see Footer's toggle bar) so multiple toggles are spaced by flexbox, not manual positioning.
const ContextualMenuToggle = ({ open, onClick, icon, label }: ContextualMenuToggleProps) => (
  <div className={cn('control contextual-menu-toggle', { open })} data-graph-type="control" title={label}>
    <a className="icon" onClick={onClick}>
      {icon}
      <span className="sr-only">{label}</span>
    </a>
  </div>
)

export default ContextualMenuToggle
